import { ProductsService } from '..';
import { isUnitySalesFormat } from 'src/modules/Catalog/pages/EditProduct/types';

const valueThatRemoveTheIncreaseAmountTag = '1';
const isMinimumPurchaseAmount = key => key === 'minimum_purchase_amount';
const isStatus = key => key === 'status';
const isNotBoolean = value => !(value === true || value === false);

const applyMissingData = (changes, product, key) => {
  if (!product) return changes;

  const changesWithMissingData = changes;

  if (isMinimumPurchaseAmount(key) && changesWithMissingData[key] === '0') {
    changesWithMissingData[key] = valueThatRemoveTheIncreaseAmountTag;
  } else if (isStatus(key)) {
    if (isNotBoolean(changesWithMissingData[key])) {
      changesWithMissingData[key] = product[key];
    }
  } else if (!changesWithMissingData[key].length) {
    changesWithMissingData[key] = product[key];
  }

  return changesWithMissingData;
};

const applySalesFormatChange = (changes, salesFormat) => {
  const formattedChanges = changes;

  if (isUnitySalesFormat(salesFormat)) {
    formattedChanges.increase_amount = valueThatRemoveTheIncreaseAmountTag;
  } else {
    const updatedMinimumAmount =
      formattedChanges.minimum_purchase_amount *
      formattedChanges.increase_amount;
    formattedChanges.minimum_purchase_amount = updatedMinimumAmount.toString();
  }

  return formattedChanges;
};

const applyDescriptionChanges = (changes, product) => {
  const changesWithDescription = changes;

  if (product?.body_html === changesWithDescription.body_html) {
    delete changesWithDescription.body_html;
  } else {
    changesWithDescription.previous_body_html = product?.body_html;
  }

  return changesWithDescription;
};

const refineChanges = (changes, product, salesFormat) => {
  if (!changes) return changes;

  let refinedChanges = { ...changes };

  Object.keys(refinedChanges).forEach(key => {
    refinedChanges = applyMissingData(refinedChanges, product, key);
  });

  refinedChanges = applySalesFormatChange(refinedChanges, salesFormat);
  refinedChanges = applyDescriptionChanges(refinedChanges, product);

  return refinedChanges;
};

export const updateProduct = async (
  id,
  productState,
  currentProduct,
  salesFormat,
) => {
  const changesProduct = refineChanges(
    productState,
    currentProduct?.current,
    salesFormat,
  );

  try {
    await ProductsService.updateProduct({ id, changesProduct });
  } catch (error) {
    return false;
  }

  return true;
};
